import { useQuery } from "@tanstack/react-query";
import { Navigate, Outlet, useLocation } from "react-router";
import { Spinner } from "@/components/ui/surface";
import { meQuery } from "@/lib/queries";

/** Only lets signed-in people through; everyone else goes to sign-in and comes back after. */
export function RequireAuth() {
  const { data: me, isPending } = useQuery(meQuery);
  const location = useLocation();
  if (isPending) return <Spinner label="Checking your session" />;
  if (!me) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }
  return <Outlet />;
}

/** Only safe, same-app paths are allowed as post-login redirects (no open redirects). */
export function safeNext(value: string | null): string {
  if (!value?.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return "/app";
  return value;
}
